// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IPI7G{color:#b2b2b2}", "",{"version":3,"sources":["webpack://./src/plugins/packages/dramroom/components/organisms/products/productSingleResult/resultHead.module.scss"],"names":[],"mappings":"AAAA,OACI,aAAA","sourcesContent":[".additionalName {\n    color: #b2b2b2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"additionalName": "IPI7G"
};
export default ___CSS_LOADER_EXPORT___;
